import axios from "axios";
var isAlreadyFetchingAccessToken = false
var axiosConfig = {
  storageTokenKeyName: 'accessToken',
  storageRefreshTokenKeyName: 'refreshToken',
  tokenType: 'Bearer',
  refreshEndpoint: 'api/Account/RefreshToken',
  logoutEndpoint: 'api/Account/Logout',
}

var subscribers = []
var bearer = localStorage.getItem("accessToken") ? localStorage.getItem("accessToken") : '';
axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? window.GLOBAL_BACKEND_URL : process.env.VUE_APP_BACKEND_URL;
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
axios.defaults.withCredentials = true;
axios.interceptors.request.use(
  async function (config) {
    // config.headers.common["Authorization"] = `Bearer ${bearer}`;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

const config = {
  baseURL: process.env.NODE_ENV === 'production' ? window.GLOBAL_BACKEND_URL : process.env.VUE_APP_BACKEND_URL,
  header: {
    "X-Requested-With": "XMLHttpRequest",
    "Access-Control-Allow-Origin": "*",
  },
};
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    updateResponse(config, "response");
    await watchIfUnauthorized(error);
    return Promise.reject(error);
  }
);

export const api = axios.create({
  ...config,
  baseURL: config.baseURL + "api/",
});
api.interceptors.request.use(
  async function (config) {
    updateResponse(config, "request");
    // let jwtBearer = await getJwtBearer(bearer);
    // config.headers.common["Authorization"] = `Bearer ${jwtBearer}`;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
api.interceptors.response.use(
  (response) => {
    updateResponse(response.config, "response");
    return response;
  },
  async (error) => {
    updateResponse(error.config, "response");
    await watchIfUnauthorized(error);
    return Promise.reject(error);
  }
);

export const serviceAPI = axios.create({
  ...config,
  baseURL: config.baseURL + "service/",
});
serviceAPI.interceptors.request.use(
  async function (config) {
    updateResponse(config, "request");
    let jwtBearer = await getJwtBearer(bearer);
    config.headers.common["Authorization"] = `Bearer ${jwtBearer}`;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
serviceAPI.interceptors.response.use(
  (response) => {
    updateResponse(response.config, "response");
    return response;
  },
  async (error) => {
    updateResponse(error.config, "response");
    await watchIfUnauthorized(error);
    return Promise.reject(error);
  }
);

export const procurementAPI = axios.create({
  ...config,
  baseURL: config.baseURL + "procurement/",
});
procurementAPI.interceptors.request.use(
  async (config) => {
    updateResponse(config, "request");
    // let jwtBearer = await getJwtBearer(bearer);
    // config.headers.common["Authorization"] = `Bearer ${jwtBearer}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
procurementAPI.interceptors.response.use(
  (response) => {
    updateResponse(response.config, "response");
    return response;
  },
  async (error) => {
    updateResponse(error.config, "response");
    await watchIfUnauthorized(error);
    return Promise.reject(error);
  }
);

export const coreAPI = axios.create({
  ...config,
  baseURL: config.baseURL + "core/",
});
coreAPI.interceptors.request.use(
  async (config) => {
    updateResponse(config, "request");
    // let jwtBearer = await getJwtBearer(bearer);
    // config.headers.common["Authorization"] = `Bearer ${jwtBearer}`;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
coreAPI.interceptors.response.use(
  (response) => {
    updateResponse(response.config, "response");
    return response;
  },
  async (error) => {
    updateResponse(error.config, "response");
    await watchIfUnauthorized(error);
    return Promise.reject(error);
  }
);

export const financeAPI = axios.create({
  ...config,
  baseURL: config.baseURL + "finance/",
});
financeAPI.interceptors.request.use(
  async function (config) {
    updateResponse(config, "request");
    // let jwtBearer = await getJwtBearer(bearer);
    // config.headers.common["Authorization"] = `Bearer ${jwtBearer}`;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
financeAPI.interceptors.response.use(
  (response) => {
    updateResponse(response.config, "response");
    return response;
  },
  async (error) => {
    updateResponse(error.config, "response");
    await watchIfUnauthorized(error);
    return Promise.reject(error);
  }
);

export const planningAPI = axios.create({
  ...config,
  baseURL: config.baseURL + "planning/",
});

planningAPI.interceptors.request.use(
  async function (config) {
    updateResponse(config, "request");
    // let jwtBearer = await getJwtBearer(bearer);
    // config.headers.common["Authorization"] = `Bearer ${jwtBearer}`;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

planningAPI.interceptors.response.use(
  (response) => {
    updateResponse(response.config, "response");
    return response;
  },
  async (error) => {
    updateResponse(error.config, "response");
    await watchIfUnauthorized(error);
    return Promise.reject(error);
  }
);
export const PlanningAPI = axios.create({
  ...config,
  baseURL: config.baseURL + "Planning/",
});

PlanningAPI.interceptors.request.use(
  async function (config) {
    updateResponse(config, "request");
    // let jwtBearer = await getJwtBearer(bearer);
    // config.headers.common["Authorization"] = `Bearer ${jwtBearer}`;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

PlanningAPI.interceptors.response.use(
  (response) => {
    updateResponse(response.config, "response");
    return response;
  },
  async (error) => {
    updateResponse(error.config, "response");
    await watchIfUnauthorized(error);
    return Promise.reject(error);
  }
);

export const deliveryUnitAPI = axios.create({
  ...config,
  baseURL: config.baseURL + "DeliveryUnit/",
});

deliveryUnitAPI.interceptors.request.use(
  async function (config) {
    updateResponse(config, "request");
    // let jwtBearer = await getJwtBearer(bearer);
    // config.headers.common["Authorization"] = `Bearer ${jwtBearer}`;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

deliveryUnitAPI.interceptors.response.use(
  (response) => {
    updateResponse(response.config, "response");
    return response;
  },
  async (error) => {
    updateResponse(error.config, "response");
    await watchIfUnauthorized(error);
    return Promise.reject(error);
  }
);

export const propertyAPI = axios.create({
  ...config,
  baseURL: config.baseURL + "property/",
});
propertyAPI.interceptors.request.use(
  async function (config) {
    updateResponse(config, "request");
    // let jwtBearer = await getJwtBearer(bearer);
    // config.headers.common["Authorization"] = `Bearer ${jwtBearer}`;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
propertyAPI.interceptors.response.use(
  (response) => {
    updateResponse(response.config, "response");
    return response;
  },
  async (error) => {
    updateResponse(error.config, "response");
    await watchIfUnauthorized(error);
    return Promise.reject(error);
  }
);

export const PropertyAPI = axios.create({
  ...config,
  baseURL: config.baseURL + "Property/",
});
PropertyAPI.interceptors.request.use(
  async function (config) {
    updateResponse(config, "request");
    // let jwtBearer = await getJwtBearer(bearer);
    // config.headers.common["Authorization"] = `Bearer ${jwtBearer}`;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
PropertyAPI.interceptors.response.use(
  (response) => {
    updateResponse(response.config, "response");
    return response;
  },
  async (error) => {
    updateResponse(error.config, "response");
    await watchIfUnauthorized(error);
    return Promise.reject(error);
  }
);

export const inspectionAPI = axios.create({
  ...config,
  baseURL: config.baseURL + "inspection/",
});
inspectionAPI.interceptors.request.use(
  async function (config) {
    updateResponse(config, "request");
    // let jwtBearer = await getJwtBearer(bearer);
    // config.headers.common["Authorization"] = `Bearer ${jwtBearer}`;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
inspectionAPI.interceptors.response.use(
  (response) => {
    updateResponse(response.config, "response");
    return response;
  },
  async (error) => {
    updateResponse(error.config, "response");
    await watchIfUnauthorized(error);
    return Promise.reject(error);
  }
);
export const inspectionIarAPI = axios.create({
  ...config,
  baseURL: config.baseURL + "Inspection/Iar",
});
inspectionIarAPI.interceptors.request.use(
  async function (config) {
    updateResponse(config, "request");
    // let jwtBearer = await getJwtBearer(bearer);
    // config.headers.common["Authorization"] = `Bearer ${jwtBearer}`;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
inspectionIarAPI.interceptors.response.use(
  (response) => {
    updateResponse(response.config, "response");
    return response;
  },
  async (error) => {
    updateResponse(error.config, "response");
    await watchIfUnauthorized(error);
    return Promise.reject(error);
  }
);
export const inspectionIarItemAPI = axios.create({
  ...config,
  baseURL: config.baseURL + "Inspection/IarItem",
});
inspectionIarItemAPI.interceptors.request.use(
  async function (config) {
    updateResponse(config, "request");
    // let jwtBearer = await getJwtBearer(bearer);
    // config.headers.common["Authorization"] = `Bearer ${jwtBearer}`;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
inspectionIarItemAPI.interceptors.response.use(
  (response) => {
    updateResponse(response.config, "response");
    return response;
  },
  async (error) => {
    updateResponse(error.config, "response");
    await watchIfUnauthorized(error);
    return Promise.reject(error);
  }
);


export const dtsAPI = axios.create({
  ...config,
  baseURL: config.baseURL + "dts/api",
});
dtsAPI.interceptors.request.use(
  async function (config) {
    updateResponse(config, "request");
    // let jwtBearer = await getJwtBearer(bearer);
    // config.headers.common["Authorization"] = `Bearer ${jwtBearer}`;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
dtsAPI.interceptors.response.use(
  (response) => {
    updateResponse(response.config, "response");
    return response;
  },
  async (error) => {
    updateResponse(error.config, "response");
    await watchIfUnauthorized(error);
    return Promise.reject(error);
  }
);

function setToken(value) {
  localStorage.setItem(axiosConfig.storageTokenKeyName, value)
}
function setRefreshToken(value) {
  localStorage.setItem(axiosConfig.storageRefreshTokenKeyName, value)
}
function getToken() {
  return localStorage.getItem(axiosConfig.storageTokenKeyName)
}
function getRefreshToken() {
  return localStorage.getItem(axiosConfig.storageRefreshTokenKeyName)
}

function refreshToken() {
  return axios.post(axiosConfig.refreshEndpoint
    //   , {
    //     refreshToken: getRefreshToken(),
    //     accessToken: getToken()
    // }
  )
}

function updateResponse(response, type) {
  if (
    response.method.toLowerCase() === "post" ||
    response.method.toLowerCase() === "put" ||
    response.method.toLowerCase() === "delete"
  ) {
    if (type === "request") {
      if (!response.data || !response.data.removeLoading) {
        document.getElementById("full-page-loader").classList.remove("d-none");
      }
    } else {
      document.getElementById("full-page-loader").classList.add("d-none");
    }
  }
}
function onAccessTokenFetched(accessToken) {
  subscribers = subscribers.filter(callback => callback(accessToken))
}
function forceLogout() {
  axios.post(
    axiosConfig.logoutEndpoint
  ).finally(() => {
    localStorage.clear();
    window.location.href = '/login';
  });
}
function addSubscriber(callback) {
  subscribers.push(callback)
}
async function watchIfUnauthorized(error) {
  const { config, response } = error
  const originalRequest = config
  if (response && response.status == 401) {
    if (!isAlreadyFetchingAccessToken) {
      isAlreadyFetchingAccessToken = true
      await refreshToken().then(r => {
        if (r.data.error) {
          console.clear();
          return forceLogout();
        }
        console.clear();
        isAlreadyFetchingAccessToken = false;
        // setToken(r.data.accessToken)
        // setRefreshToken(r.data.refreshToken)
        // onAccessTokenFetched(r.data.accessToken)
      })
        .catch((e) => {
          console.clear();
          return forceLogout();
        })
    }
    const retryOriginalRequest = new Promise(resolve => {
      addSubscriber(accessToken => {
        // originalRequest.headers.Authorization = `${axiosConfig.tokenType} ${accessToken}`
        resolve(axios(originalRequest))
      })
    })
    return retryOriginalRequest
  }
}
async function getJwtBearer() {
  if (!localStorage.getItem(axiosConfig.storageTokenKeyName)) return '';
  try {
    const payload = JSON.parse(atob(localStorage.getItem(axiosConfig.storageTokenKeyName).split('.')[1]));
    const currentTime = Math.floor(Date.now() / 1000);
    if (payload.exp < currentTime) {
      console.clear()
      isAlreadyFetchingAccessToken = true
      return await refreshToken().then(r => {
        if (r.data.error) {
          return forceLogout();
        }
        setToken(r.data.accessToken)
        setRefreshToken(r.data.refreshToken)
        isAlreadyFetchingAccessToken = false
        return r.data.accessToken;
      })
        .catch((e) => {
          return forceLogout();
        })
    } else {
      return localStorage.getItem(axiosConfig.storageTokenKeyName);
    }
  } catch (e) {
    return '';
  }
}